
import * as defaultImport from "@splunk/splunk-utils/url";
export * from "@splunk/splunk-utils/url";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
